let localStream = null;
//let peerConnection = null;
let peerConnections = {};
let remoteStreams = {};
let dataChannels = {};
//let dataReceives = {};
let pitchDataReceives = {};
let downloadDataReceives = {};
let realtimeDataReceives = {};
let audioAnalyserAnimationId;
let audioContext, audioAnalyser, audioMicrophoneSource;
let isMicrophoneActive;
let onPitchChange;
let onDownloadChange;
let onRealtimeChange;
let onWarnChange;
//let onFailedReconnectChange;
let onEmptyPeerChange;
let mySocketId;
let myUsers = {};
//let dataSend = { pitch: 0, download: 0 };
let isInitialized;
let isOneDirect;
const clearUsersWebrtc = () => {
    for (const sub in myUsers) {
        delete myUsers[sub];
    }
};
export const setUsersWebrtc = (users) => {
    clearUsersWebrtc();
    for (const sub in users) {
        const user = users[sub];
        myUsers[sub] = { ...user };
    }
};
// Dapatkan stream audio lokal
export const setupLocalStreamWebrtc = async (isGameOneDirect, socket, users, onPitch, onDownload, onWarn, onRealtime, onEmptyPeer) => {
    try {
        localStream = await navigator.mediaDevices.getUserMedia({
            audio: {
                echoCancellation: true,
                noiseSuppression: true,
                autoGainControl: true
            }
        });

        console.log("✅ Izin mikrofon diberikan.");
        // Gunakan localStream di WebRTC, audio element, dll
    } catch (err) {
        console.warn("❌ Gagal mendapatkan akses mikrofon:", err);

        if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
            alert("Akses mikrofon ditolak.\nSilakan buka pengaturan browser atau aplikasi dan izinkan mikrofon.");
        } else if (err.name === "NotFoundError") {
            alert("Tidak ada perangkat mikrofon terdeteksi.");
        } else {
            alert("Terjadi kesalahan saat mengakses mikrofon: " + err.message);
        }
    }

    setUsersWebrtc(users);

    isOneDirect = isGameOneDirect;

    mySocketId = socket.id;

    let isCallAll = true;
    if (isOneDirect && !checkCurrentHost()) {
        isCallAll = false;
    }

    for (const sub in users) {
        const callUser = users[sub];
        if (!isCallAll && !callUser.isHost) continue;
        if (callUser.id === socket.id) continue;
        await startAudioCallWebrtc(socket, callUser.id);
    }

    console.log(`socket:${socket}`);
    console.log(`setupLocalStreamWebrtc:${users.length}`);
    onPitchChange = onPitch;
    onDownloadChange = onDownload;
    onRealtimeChange = onRealtime;
    onWarnChange = onWarn;
    //onFailedReconnectChange = onFailedReconnect;
    onEmptyPeerChange = onEmptyPeer;

    microphoneChangeWebrtc();

    microphoneWebrtc(false);

    isInitialized = true;
};

// Fungsi untuk membuat koneksi WebRTC
function createPeerConnection(socket, receiver) {
    const config = {
        iceServers: [
            { urls: 'stun:stun.l.google.com:19302' },
            {
                urls: 'turn:202.10.44.114:3478',
                username: 'webrtcuser',
                credential: 'webrtcpass'
            }
        ]
    };
    const peerConnection = new RTCPeerConnection(config);

    // Tambahkan semua track dari localStream ke peerConnection
    localStream.getTracks().forEach(track => {
        peerConnection.addTrack(track, localStream);
    });

    // Buat data channel untuk mengirim data
    const dataChannel = peerConnection.createDataChannel("data");
    // Event ketika data channel terbuka
    // dataChannelParseWebrtc(dataChannel);
    dataChannels[receiver] = dataChannel;

    peerConnection.ondatachannel = (event) => {
        const dataChannel = event.channel;
        dataChannelParseWebrtc(dataChannel, receiver);
    };

    peerConnection.onicecandidate = (event) => {
        if (event.candidate) {
            socket.emit("signal", {
                receiver,
                signal: { candidate: event.candidate }
            });
        }
    };
    peerConnection.oniceconnectionstatechange = () => {
        const state = peerConnection.iceConnectionState;
        if (state === "disconnected" || state === "failed" || state === "closed") {
            removePitchDataReceiveWebrtc(receiver);
            removeDownloadDataReceiveWebrtc(receiver);
            removeRealtimeDataReceiveWebrtc(receiver);
            removeDataChannelWebrtc(receiver);
            removePeerConnectionWebrtc(receiver);
            removeRemoteStreamWebrtc(receiver);
            //console.log(peerConnections);
            console.log(`Remote peer ${receiver} has disconnected. peer list count ${Object.keys(peerConnections).length}, remoteStreams list count ${Object.keys(remoteStreams).length}`);

            handleWarnWebrtc(receiver, 1);

            // Coba reconnect
            if (isInitialized) {
                let isReconnect = false;
                let isHostOut = false;

                // Hapus user dari myUsers jika ada
                if (myUsers[receiver]) {
                    isHostOut = myUsers[receiver].isHost;
                    delete myUsers[receiver];
                }
                const noActivePeers = Object.keys(peerConnections).length === 0;
                if (!isOneDirect) {
                    const hasOtherUsers = Object.keys(myUsers).length > 1;

                    if (noActivePeers && hasOtherUsers) {
                        isReconnect = true;
                    }
                }
                else {
                    if ((isHostOut || noActivePeers) && !checkCurrentHost()) {
                        isReconnect = true;
                    }
                }
                // Trigger reconnect jika dibutuhkan
                if (isReconnect) {
                    onEmptyPeerChange();
                    console.log("---need to reconnect---");
                }
            }
        }
    };
    // peerConnection.onconnectionstatechange = () => {
    //     const state = peerConnection.connectionState;
    //     // if (state === "disconnected" || state === "failed" || state === "closed") {
    //     //     console.log(`BBB Remote peer ${receiver} has disconnected.`);
    //     // }
    //     if (state === "disconnected" || state === "failed") {
    //         onFailedReconnectChange();
    //     }
    // };
    peerConnection.ontrack = (event) => {
        const remoteAudio = new
            Audio();
        remoteAudio.srcObject = event.streams[0];
        remoteAudio.play();
        remoteStreams[receiver] = remoteAudio;
    };
    // dataChannel.onopen = () => {
    //     console.log("Data Channel opened:", userId);
    // };
    // dataChannel.onclose = () => {
    //     console.log("Data Channel closed:", userId);
    // };

    return peerConnection;
}
function checkCurrentHost() {
    let isHost = false;
    const host = Object.values(myUsers).find(user => user.isHost === true);
    if (host) {
        isHost = (host.id == mySocketId);
    }
    return isHost;
}
function dataChannelParseWebrtc(dataChannel, receiver) {
    dataChannel.onopen = () => {
        console.log("Data Channel opened", receiver);
    };

    // Event ketika menerima pesan melalui data channel
    dataChannel.onmessage = (event) => {
        var receive = JSON.parse(event.data);
        if (receive.key == "pitch") {
            pitchDataReceives[receiver] = receive;
            //console.log(`pitch:${receive.value}`);
            handlePitchWebrtc(receiver, receive.value);
        }
        else if (receive.key == "download") {
            downloadDataReceives[receiver] = receive;
            //console.log(`download:${receive.value}`);
            handleDownloadWebrtc(receiver, receive.value);
        }
        else if (receive.key == "realtime") {
            realtimeDataReceives[receiver] = receive;
            //console.log(`realtime:${receive.value}`);
            handleRealtimeWebrtc(receive.value);
        }
    };
}
function handlePitchWebrtc(receiver, pitch) {
    let voiceLevel = 0;
    if (pitch > 4 && pitch < 8) {
        voiceLevel = 2;
    }
    else if (pitch >= 8 && pitch <= 16) {
        voiceLevel = 4;
    }
    else if (pitch > 16) {
        voiceLevel = 8;
    }
    onPitchChange(receiver, voiceLevel);
}
function handleWarnWebrtc(receiver, val) {
    onWarnChange(receiver, val);
}
function handleDownloadWebrtc(receiver, val) {
    onDownloadChange(receiver, val);
}
function handleRealtimeWebrtc(val) {
    onRealtimeChange(val);
}
function removeAudioContextWebrtc() {
    if (localStream) {
        localStream.getTracks().forEach(track => track.stop());
        localStream = null;
    }

    if (audioAnalyserAnimationId) {
        cancelAnimationFrame(audioAnalyserAnimationId);
        audioAnalyserAnimationId = null;
    }

    if (audioMicrophoneSource) {
        audioMicrophoneSource.disconnect();
        audioMicrophoneSource = null;
    }

    if (audioAnalyser) {
        audioAnalyser.disconnect?.();
        audioAnalyser = null;
    }

    if (audioContext && audioContext.state !== 'closed') {
        audioContext.close();
    }
    audioContext = null;
}
function removePitchDataReceiveWebrtc(userId) {
    if (pitchDataReceives[userId]) {
        delete pitchDataReceives[userId];
    }
}
function removeDownloadDataReceiveWebrtc(userId) {
    if (downloadDataReceives[userId]) {
        delete pitchDataReceives[userId];
    }
}
function removeRealtimeDataReceiveWebrtc(userId) {
    if (realtimeDataReceives[userId]) {
        delete realtimeDataReceives[userId];
    }
}
function removeDataChannelWebrtc(userId) {
    if (dataChannels[userId]) {
        dataChannels[userId].close();
        delete dataChannels[userId];
        console.log(`Data Channel closed for user: ${userId}`);
    }
}
function removeRemoteStreamWebrtc(userId) {
    if (remoteStreams[userId]) {
        remoteStreams[userId].pause();
        remoteStreams[userId].srcObject = null;
        delete remoteStreams[userId];
    }
}
function removePeerConnectionWebrtc(userId) {
    if (peerConnections[userId]) {
        peerConnections[userId].close();
        delete peerConnections[userId];
    }
}

// Mulai panggilan audio
export const startAudioCallWebrtc = async (socket, receiver) => {
    if (!peerConnections[receiver]) {
        peerConnections[receiver] = createPeerConnection(socket, receiver);
    }
    const peerConnection = peerConnections[receiver];

    // ✅ Cek jika sudah dalam proses negosiasi
    if (peerConnection.signalingState !== 'stable') {
        console.warn(`Skipping offer: signalingState is ${peerConnection.signalingState}`);
        return;
    }

    try {
        const offer = await peerConnection.createOffer();
        await peerConnection.setLocalDescription(offer);

        socket.emit("signal", {
            receiver,
            signal: { offer }
        });
    } catch (error) {
        console.error("Failed to start audio call:", error);
    }
};
// Fungsi end Audio Call
export const endAudioCallWebrtc = () => {
    removeAudioContextWebrtc();

    Object.keys(pitchDataReceives).forEach(userId => {
        removePitchDataReceiveWebrtc(userId);
    });

    Object.keys(downloadDataReceives).forEach(userId => {
        removeDownloadDataReceiveWebrtc(userId);
    });

    Object.keys(realtimeDataReceives).forEach(userId => {
        removeRealtimeDataReceiveWebrtc(userId);
    });

    Object.keys(dataChannels).forEach(userId => {
        removeDataChannelWebrtc(userId);
    });

    Object.keys(peerConnections).forEach(userId => {
        removePeerConnectionWebrtc(userId);
    });

    //remoteStreams = []; // Reset daftar remote streams
    Object.keys(remoteStreams).forEach(userId => {
        removeRemoteStreamWebrtc(userId);
    });

    isInitialized = false;
    isMicrophoneActive = false;
    clearUsersWebrtc();
    console.log('Disconnected from audio call');
};
// Fungsi untuk menghidupkan/mematikan mikrofon
export const microphoneWebrtc = (enabled) => {
    isMicrophoneActive = enabled;
    if (localStream) {
        localStream.getTracks().forEach(track => {
            if (track.kind === "audio") {
                track.enabled = enabled; // Menghidupkan/mematikan track audio
            }
        });

        sendMicrophonePitchWebrtc(0);
    }
};
function microphoneChangeWebrtc() {
    if (!audioContext) {
        audioContext = new AudioContext();
        audioAnalyser = audioContext.createAnalyser();
        audioMicrophoneSource = audioContext.createMediaStreamSource(localStream);
        audioMicrophoneSource.connect(audioAnalyser);
        audioAnalyser.fftSize = 256;
    }

    const dataArray = new Uint8Array(audioAnalyser.frequencyBinCount);

    // Fungsi untuk mendapatkan level audio
    const getAudioLevel = () => {
        if (audioAnalyser) {
            audioAnalyser.getByteFrequencyData(dataArray);
            let sum = 0;
            dataArray.forEach(value => sum += value);
            const average = sum / dataArray.length; // Nilai rata-rata level audio

            // Tampilkan atau gunakan nilai rata-rata ini sesuai kebutuhan
            // console.log("Audio level:", average);
            if (isMicrophoneActive) {
                sendMicrophonePitchWebrtc(average);
            }
        }
        audioAnalyserAnimationId = requestAnimationFrame(getAudioLevel); // Loop selama audio aktif
    };

    getAudioLevel();
}
function sendMicrophonePitchWebrtc(pitch) {
    for (const userId in dataChannels) {
        if (dataChannels[userId].readyState === "open") {
            var send = { key: "pitch", value: pitch };
            //console.log("pitch:" + pitch);
            dataChannels[userId].send(JSON.stringify(send));
        }
    }
    //console.log(`local pitch: ${pitch}`);
    handlePitchWebrtc(mySocketId, pitch);
}
export const sendDownloadWebrtc = (val) => {
    for (const userId in dataChannels) {
        if (dataChannels[userId].readyState === "open") {
            var send = { key: "download", value: val };
            //console.log("download:" + val);
            dataChannels[userId].send(JSON.stringify(send));
        }
    }
    handleDownloadWebrtc(mySocketId, val);
};
export const sendRealtimeWebrtc = (val) => {
    for (const userId in dataChannels) {
        if (dataChannels[userId].readyState === "open") {
            var send = { key: "realtime", value: val };
            //console.log("download:" + val);
            dataChannels[userId].send(JSON.stringify(send));
        }
    }
};
// Menangani sinyal dari pengguna lain
export const handleSignalWebrtc = async (socket, signal, sender, onUpdateStreams) => {
    if (!peerConnections[sender]) {
        peerConnections[sender] = createPeerConnection(socket, sender);
    }
    const peerConnection = peerConnections[sender];

    onUpdateStreams();

    if (signal.offer) {
        console.log(`Received offer from ${sender}`);

        const signalingState = peerConnection.signalingState;
        if (signalingState !== 'stable') {
            console.warn(`Peer connection not stable (${signalingState}), skipping offer`);
            return;
        }

        try {
            await peerConnection.setRemoteDescription(new RTCSessionDescription(signal.offer));

            const answer = await peerConnection.createAnswer();
            await peerConnection.setLocalDescription(answer);

            socket.emit("signal", {
                receiver: sender,
                signal: { answer }
            });
        } catch (err) {
            console.error("Failed to handle offer:", err);
        }

    } else if (signal.answer) {
        console.log(`Received answer from ${sender}`);
        try {
            await peerConnection.setRemoteDescription(new RTCSessionDescription(signal.answer));
        } catch (err) {
            console.error("Failed to handle answer:", err);
        }

    } else if (signal.candidate) {
        console.log(`Received ICE candidate from ${sender}`);
        try {
            await peerConnection.addIceCandidate(new RTCIceCandidate(signal.candidate));
        } catch (err) {
            console.error("Failed to add ICE candidate:", err);
        }
    }
};

// export const removePeerConnectionWebrtc = (userId) => {
//     if (peerConnections[userId]) {
//         console.log('removePeerConnectionWebrtc')
//         peerConnections[userId].close();
//         delete peerConnections[userId];
//     }
// };

// Mendapatkan stream lokal
export const getLocalStreamWebrtc = () => localStream;

// Mendapatkan peer connection
//export const getPeerConnectionWebrtc = () => peerConnection;

// Mendapatkan remote streams
export const getRemoteStreamsWebrtc = () => remoteStreams;
export const isReadyWebrtc = () => isInitialized;
